import React from "react";
import "./Banner.css";
export default function Banner({ banner }) {
  return (
    <div className="terms-banner-wrapper">
      <img src={banner} />
    </div>
  );
}
